/**
 * Resolves the angler's ACTIVE water type ("saltwater" | "freshwater" | "").
 *
 * Anglers may enrol in saltwater, freshwater, or both. When they fish both,
 * the dashboard asks (once per app session) which mode they're in and stores
 * the choice in sessionStorage under `the99.fishingMode`. This helper reads the
 * same key so other screens (e.g. CatchScreen) can react to freshwater mode
 * without duplicating the dashboard's state.
 */
export function getActiveWaterType(userProfile) {
  const arr = Array.isArray(userProfile?.waterTypes) ? userProfile.waterTypes : null;
  const list = arr && arr.length > 0
    ? arr
    : (userProfile?.waterType ? [userProfile.waterType] : []);
  const enrolled = list.map((w) => String(w || "").toLowerCase()).filter(Boolean);

  const fishesBoth = enrolled.includes("saltwater") && enrolled.includes("freshwater");
  if (!fishesBoth) return enrolled[0] || "";

  try {
    return sessionStorage.getItem("the99.fishingMode") || "";
  } catch {
    return "";
  }
}

export function isFreshwaterActive(userProfile) {
  return getActiveWaterType(userProfile) === "freshwater";
}

export default getActiveWaterType;
